export const getSizotsaFuneralClaim = (state) => state.sizotsaFuneralClaim;
